import {Injectable} from "@angular/core";
import {PopoverComponent} from "../../@mos-core/components/popover/popover.component";

@Injectable({ providedIn: 'root' })
export class PopoverService {
    private openPopovers: PopoverComponent[] = [];

    public register(openPopover: PopoverComponent) {
        const index = this.openPopovers.indexOf(openPopover);
        if (index === -1) {
            this.openPopovers.push(openPopover);
        }
    }

    public unregister(popover: PopoverComponent) {
        const index = this.openPopovers.indexOf(popover);
        if (index > -1) {
            this.openPopovers.splice(index, 1);
        }
    }

    public getOpenPopovers(): PopoverComponent[] {
        return this.openPopovers;
    }
}